<template>
  <vx-card class="mt-2 pagebreak-inside-avoid">
    <table class="table table-bordered">
      <tr class="title p-1 w-full">
        <th colspan="3">
          DADOS DA {{ isQuotation ? 'COTAÇÃO' : 'PROPOSTA' }} DE ENDOSSO
        </th>
      </tr>
      <tr>
        <td v-if="isProposal" class="pl-3">
          <b>N° Proposta de Endosso:</b> {{ proposalData.proposalNumber }}
        </td>
        <td class="pl-3">
          <b>N° Cotação de Endosso:</b> {{ proposalData.idProposta }}
        </td>
        <td class="pl-3">
          <b>Data da {{ isQuotation ? 'Cotação' : 'Proposta' }}:</b>
          {{
            isQuotation
              ? proposalData.dataEmissao
              : functions.formataDataHoraPadraoBR(
                  proposalData.proposalDate,
                  true,
                )
          }}
        </td>
        <td v-if="isQuotation" class="pl-3">
          <b>Validade da cotação:</b>
          {{ proposalData.dataVencimentoCotacao }}
        </td>
      </tr>
      <tr>
        <td class="pl-3" colspan="2"><b>Tipo: </b> {{ operationType }}</td>
        <td class="pl-3">
          <b>Vigência: </b>
          24:00 de
          {{
            functions.formataDataHoraPadraoBR(
              proposalData.inicioVigencia,
              false,
            )
          }}
        </td>
      </tr>
    </table>
    <div
      v-if="customSectionsMsgs.DATA"
      style="text-align: justify"
      class="pl-3 pt-3"
      v-html="customSectionsMsgs.DATA"
    ></div>
  </vx-card>
</template>

<script>
import functions from '../../../utils/functions';

export default {
  name: 'EndorsementContractQuotationProposalData',
  props: {
    isQuotation: {
      type: Boolean,
      required: false,
      default: false,
    },
    isProposal: {
      type: Boolean,
      required: false,
      default: false,
    },
    operationType: {
      type: String,
      required: false,
      default: '',
    },
    proposalData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    customSectionsMsgs: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      functions,
    };
  },
};
</script>
